import { z } from 'zod';

export const AddReferredBySchema = z.object({
   code: z.string().min(5),
});
